const setPreferenceCenterEmail = require("./setPreferenceCenterEmail");
const checkPreferenceCenterOption = require("./checkPreferenceCenterOption");
const showPreferenceCenterPhoneNumberField = require("./showPreferenceCenterPhoneNumberField");
const setPreferenceCenterPhoneNumber = require("./setPreferenceCenterPhoneNumber");
const setPreferenceCenterCountryToUS = require("./setPreferenceCenterCountryToUS");

/**
 * @param preferenceCenter {HTMLElement}
 * @param preferenceCenterOptions {PreferenceCenterOptions}
 * @return {void}
 */
module.exports = function setPreferenceCenterOptions(preferenceCenter, preferenceCenterOptions) {
    for (const name in preferenceCenterOptions) {
        const value = preferenceCenterOptions[name];

        if (value) {
            if (name === "email") {
                setPreferenceCenterEmail(preferenceCenter, value);
            } else if (name === "phoneNumber") {
                setPreferenceCenterPhoneNumber(preferenceCenter, value);
            } else if (name === "country") {
                if (value === "US") {
                    setPreferenceCenterCountryToUS(preferenceCenter);
                }
            } else {
                checkPreferenceCenterOption(preferenceCenter, name);

                if (name === "marketingSMSOptIn" && value) {
                    showPreferenceCenterPhoneNumberField(preferenceCenter);
                }
            }
        }
    }
}
